<template>
    <div class="card shadow my-2 p-1 bg-white rounded w-auto mission-small">
        <router-link :to="'/mission/' + mission.id" class="card-header mission-small-header mission-small-header-link">
            <div class="mission-small-top">
                <MissionStatusDisplay :status="mission.status" size="sm" />
                <span class="mission-small-id">#{{ mission.id }}</span>
            </div>

            <div class="mission-small-title" :title="mission.displayName || mission.name">
                <span v-if="mission.displayTime" class="mission-small-time-inline">
                    <i class="fa-regular fa-clock me-1"></i>{{ mission.displayTime }}
                </span>
                {{ mission.displayName || mission.name }}
            </div>
        </router-link>

        <div class="d-flex justify-content-center mission-map-link">
            <MapLinkDisplay :link="'/missionmap/' + mission.id" />
        </div>
        <div class="d-flex justify-content-center small mission-corridoring">
            <span v-if="mission.corridoring && mission.corridoring.name">
                {{ mission.corridoring.name }}
            </span>
            <span v-else class="fst-italic">Aucun corridoring</span>
        </div>
        <hr class="mx-2 my-2 mission-separator" />

        <div v-if="mission.members && mission.members.length" class="mt-0 px-2 mission-members">
            <MembersListCompact :mission="mission" :showHeader="false" />
        </div>
        <hr class="mx-2 my-2 mission-separator" />

        <div v-if="mission.transporteur != null" class="d-flex justify-content-center mission-vehicle-row">
            <VehicleNameDisplay :balise="mission.transporteur" compact
                class="mission-vehicle-chip mission-vehicle-chip-main" />
        </div>
        <div v-for="balise in mission.balises" :key="balise.id"
            class="d-flex justify-content-center mission-vehicle-row">
            <VehicleNameDisplay :balise="balise" compact class="rounded px-2"
                :class="balise.ongoingAlarm ? 'mission-vehicle-chip bg-blink' : 'mission-vehicle-chip mission-vehicle-chip-secondary'" />
        </div>
    </div>
</template>

<script>
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import MapLinkDisplay from '@/components/display/MapLinkDisplay.vue'
import MissionStatusDisplay from '@/components/display/MissionStatusDisplay.vue'
import MembersListCompact from '../../Components/Members/MembersListCompact.vue'

export default {
    props: ['mission'],
    components: {
        VehicleNameDisplay,
        MapLinkDisplay,
        MissionStatusDisplay,
        MembersListCompact
    }
}
</script>

<style>
.mission-small {
    width: 210px !important;
    border-radius: 16px !important;
    border: 1px solid #d6dee8;
    box-shadow:
        0 6px 18px rgba(15, 23, 42, 0.10),
        0 2px 4px rgba(15, 23, 42, 0.06) !important;
}

.mission-small-header {
    padding: 0.55rem 0.7rem 0.45rem;
    background: #ffffff;
    border-bottom: 1px solid #e8eef5;
}

.mission-small-header-link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition: background 0.15s ease, box-shadow 0.15s ease;
}

.mission-small-header-link:hover {
    background: #f8fafc;
}

.mission-small-header-link:hover .mission-small-title {
    color: #0d6efd;
}

.mission-small-header-link:hover .mission-small-id {
    color: #64748b;
}

.mission-small-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
}

.mission-small-id {
    font-size: 0.75rem;
    font-weight: 600;
    color: #94a3b8;
    white-space: nowrap;
}

.mission-small-time-inline {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin-right: 0.35rem;
    margin-bottom: 0.1rem;
    padding: 0.12rem 0.48rem;
    border-radius: 999px;
    background: rgba(13, 110, 253, 0.12);
    color: #0d6efd;
    font-size: 0.76rem;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.01em;
}

.mission-small-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;

    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-decoration: none;
    color: #0f172a;
    font-weight: 700;
    font-size: 0.92rem;
    line-height: 1.25;
    word-break: break-word;
}

.mission-small-title:hover {
    color: #0d6efd;
}

.mission-map-link {
    padding: 0.45rem 0.5rem 0.35rem;
}

.mission-corridoring {
    margin: 0 0.5rem;
    padding: 0.3rem 0.45rem;
    border-radius: 10px;
    background: rgba(13, 110, 253, 0.08);
    color: #64748b;
    line-height: 1.25;
    text-align: center;
}

.mission-separator {
    border-color: #e8eef5;
    opacity: 1;
}

.mission-members {
    font-size: 0.9rem;
}

.mission-vehicle-row {
    margin-bottom: 0.2rem;
}

.mission-vehicle-chip {
    border-radius: 10px !important;
    padding: 0.1rem 0.45rem !important;
}

.mission-vehicle-chip-main {
    background: rgba(25, 135, 84, 0.12);
}

.mission-vehicle-chip-secondary {
    background: rgba(13, 110, 253, 0.1);
}

@keyframes alarm-bg {
    from {
        background-color: rgba(255, 24, 24, 0.6);
    }

    to {
        background-color: rgba(255, 24, 24, 0.2);
    }
}

.bg-blink {
    animation-duration: 0.5s;
    animation-name: alarm-bg;
    animation-iteration-count: infinite;
    animation-direction: alternate;

}
</style>
